module.exports = __webpack_public_path__ + "static/media/news_gothic_condensed_bt-bold.10d9be58.woff2";